<script lang="ts">
import { defineComponent, PropType } from "vue";
import InlineSvg from "vue-inline-svg";
import { PoolListItem } from "@/models/pool-list-item.model";

import poolDefault from "@/assets/images/pool-icons/default.svg";
import suspendu from "@/assets/images/pool-icons/Bassin-Suspendu.svg";
import internet from "@/assets/images/pool-icons/Liaison-Internet.svg";
import radio from "@/assets/images/pool-icons/Liaison-Radio-Coffret.svg";
import hiverne from "@/assets/images/pool-icons/Bassin-Hiverne.svg";
import bluetooth from "@/assets/images/pool-icons/bluetooth.svg";

import { isHivernage } from "@/shared/utils/pool";

export default defineComponent({
  components: { InlineSvg },
  props: {
    pool: {
      required: false,
      type: Object as PropType<PoolListItem>,
    },
    isBle: {
      required: false,
      type: Boolean,
      default: false,
    },
  },
  methods: {
    getAlertColor(normalColor: string) {
      if (this.pool && this.pool.alertCount > 0) {
        return "fill-[#f2583f]";
      } else if (this.pool && this.pool.notifyCount > 0) {
        return "fill-[#fcad70]";
      } else {
        return normalColor;
      }
    },
  },
  computed: {
    picto() {
      if (this.isBle) {
        return { color: "fill-[#2A9CCA]", svg: bluetooth };
      } else if (this.pool?.suspended === 1) {
        return { color: "fill-[#00a8e1]", svg: suspendu };
      } else if (this.pool && this.pool?.lastPing > 1800) {
        return { color: "fill-[#d2b9b5]", svg: internet };
      } else if (this.pool && this.pool?.infosTime > 7200) {
        return { color: "fill-[#d2b9b5]", svg: radio };
      } else if (this.pool && isHivernage(this.pool)) {
        return { color: this.getAlertColor("fill-[#00a8e1]"), svg: hiverne };
      }
      return { color: this.getAlertColor("fill-[#83af08]"), svg: poolDefault };
    },
  },
});
</script>

<template>
  <InlineSvg :src="picto.svg" alt="pool" :class="picto.color" />
</template>
